import { render, staticRenderFns } from "./PrefectureSelect.vue?vue&type=template&id=0ebddc0c&"
import script from "./PrefectureSelect.vue?vue&type=script&lang=js&"
export * from "./PrefectureSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports